<div #errorModal class="modal" *ngIf="errorText">
    <div class="modal-body">
        <div class="modal-content">
            <div class="close" (click)="close()"><i class="fa-solid fa-circle-xmark"></i>schliessen</div>
            <div class="details">
                @if (notFound) {
                <i class="fa-solid fa-circle-exclamation"></i>
                <div class="sub-details">{{barcode}} konnte leider nicht erkannt werden.</div>
                } @else {
                <i class="fa-solid fa-circle-xmark"></i>
                <div class="sub-details">Es ist leider ein Fehler aufgetreten</div>
                <p>{{errorText}}</p>
                }

            </div>
        </div>
        <div class="submit" (click)="close()">Mit Einkauf fortfahren
        </div>
    </div>
</div>